import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import {
  Tabs,
  Tab
} from "react-bootstrap";
import { changeAttribute } from "../../actions/auth";
import { updateDigestOption } from "../../actions/settings";
import TeamSettings from "./TeamSettings";
import UserManagement from "./UserManagement";
import BulkImport from "./BulkImport";
import Notifications from "./Notifications";
import Branding from "./Branding";
import TeamProfile from './TeamProfile';
import CTA from './CTA';
import Trackers from './Trackers';
import "./Team.scss";

class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: 'account_settings'
    };
  }

  componentDidMount() {
    if (_.get(this.props, 'match.params.type', null)) {
      this.setState({ key: _.get(this.props, 'match.params.type', null) })
    }
  }

  render() {
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']", '') === 'admin';

    return (
      <div className="team-container">
        <TeamProfile />
        <div className="team-content">
          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={key => this.setState({ key })}
          >
            <Tab eventKey="account_settings" title="Application Settings">
              <TeamSettings />
            </Tab>
            <Tab eventKey="manage-users" title="User Management">
              <UserManagement history={this.props.history} />
            </Tab>
            
            {/* Branding */}
            {isAdmin &&
              <Tab eventKey="branding" title="Branding">
                <Branding />
              </Tab>
            }
            {/* CTAs */}
            { process.env.REACT_APP_FLAG_CTA === "true" && (
            <Tab eventKey="ctas" title="CTAs">
              <CTA />
            </Tab>
            )}

            {isAdmin &&
            <Tab eventKey="trackers" title="Trackers">
              <Trackers />
            </Tab>
            }
            {isAdmin && 
            <Tab eventKey="bulk_import" title="Import">
              <BulkImport />
            </Tab>
            }
            { isAdmin &&
            <Tab eventKey="notifications" title="Notifications">
              <Notifications
                digestOption={this.props.digestOption}
                updateDigestOption={this.props.updateDigestOption}
                webhooks={this.props.webhooks}
              />
            </Tab>
            }
          </Tabs>
        </div>
        <div>&nbsp;</div>
        {/* <div className="recent-history-wrapper">
          <h3>Recent activity</h3>
          <HistoryCard activities={this.props.activities} />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cognitoUser: state.auth.cognitoUser,
  user: state.auth.tenant,
  activities: state.activity.activities,
  usersCount: (state.settings?.users?.filter(u => !u.disabled && u.isConfirmed) || []).length,
  contentsCount: state?.item?.items?.length,
  digestOption: state.settings.digestOption,
  webhooks: state.settings.webhooks
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeAttribute,
    updateDigestOption
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Team);
